import { RootState } from 'src/reducers/rootReducer';

export const saveUserProfile = (
  userName: string,
  numberOfGridRow: string,
  defaultSearchTimeSpan: string,
  defaultUseSignalR: boolean,
  Id: string,
) => ({
  url: `/UserProfile`,
  body: {
    UserName: userName,
    DefaultGridRows: numberOfGridRow,
    DefaultTimeRange: defaultSearchTimeSpan,
    DefaultUseSignalR: defaultUseSignalR,
    Id: Id,
  },
  transform: (body: any) => ({
    appResponse: body.responseMessage ? body.responseMessage : body,
  }),
  update: {
    appResponse: (_: any, next: any) => next,
  },
  options: { method: 'POST' },
  force: true,
});

export const appResponseSelector = (state: RootState) => state.entities.appResponse;

export const getUserProfile = (userName: string) => ({
  url: `/UserProfile/` + userName,
  transform: (body: any) => ({
    userProfileDetail: body.responseMessage[0] ? getUserData(body.responseMessage[0]) : getUserData(body[0]),
  }),
  update: {
    userProfileDetail: (_: any, next: any) => next,
  },
  options: { method: 'GET' },
  force: true,
});

export const appUserProfileSelector = (state: RootState) => state.entities.userProfileDetail;

function getUserData(userProfile: any): any {
  userProfile.DefaultGridRows = parseInt(userProfile.DefaultGridRows);
  if (userProfile.DefaultUseSignalR == true || userProfile.DefaultUseSignalR == 'true') {
    userProfile.DefaultUseSignalR = true;
  } else {
    userProfile.DefaultUseSignalR = false;
  }
  return userProfile;
}
